import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AppointmentDetailsComponent } from './appointment-details.component';
import { TranslateModule } from '../../../shared/translate/translate.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [AppointmentDetailsComponent],
  exports: [AppointmentDetailsComponent]
})
export class AppointmentDetailsModule { }
